import { AgentProduct } from '~/configs/AgentProduct'

export const meGetAgentName = (agentProductName: string | AgentProduct) =>
  agentProductName.replace(/@.*/, '')
